export default __webpack_public_path__ + "static/media/noblog.60050f88.png";